module.exports = __webpack_public_path__ + "img/subscription.44a44052.svg";